<app-topo [dadosCertificado]="dadosCertificado" [dadosRegistro]="dadosRegistro"></app-topo>

<div class="container">
  <div class="row justify-content-md-center ">
    <div clas="col col-lg-8">
      <div class="card mb-3">
        <div class="card-header backgroundHeader text-center">
            <!--{{ mensagem }}-->
            Mensagem do Sistema
        </div>
        <div class="card-body backgroundBody">
          <p class="card-text">          
            <span class="text-left" [innerHTML]="mensagem"></span> 
            <br><br>
            Para baixar o contrato <b><u><a (click)="downloadContrato()" style="cursor: pointer;">clique aqui</a></u></b>.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>